module.exports = __webpack_public_path__ + "img/1543102231.4f7f20b8.jpg";